import {ProductsRelDocs} from "../../interfaces";
import PRDGetAccess from "./prd-get-accesst";
import PRDPriceNote from "./prd-price-note";
interface IProductBuyButtonProps {
    product: ProductsRelDocs,
    isGoogleShoppingFeed?: boolean,
}
/**
 * the entry point
 */
const ProductSingleIncludedSBS= (props: IProductBuyButtonProps) => {

    const  product = props.product;
    const isProductNote = !product.skuEnabled && product.note !== null && product.note !== '';
    //const productsRelDocsInitialSelected = useAppSelector((store) => store.productsRelDocsInitialSelected);

    return (
                <>
                    {isProductNote && <PRDPriceNote product={product}/>}

                    {!isProductNote && <PRDGetAccess  product={product}
                                   classTryIt="text-white"
                                   classEx="my-6 md:my-0 lg:mt-2 "
                                   classBtn="py-3 px-12"
                                   source="product-single"/>}
                    {/*{ productsRelDocsInitialSelected.includedInSBS > 0 && <ProductSBSTierNote product={product} />}*/}

                </>
    )
};

export default ProductSingleIncludedSBS;